<div class="max-w-6xl mx-auto p-4 sm:p-6">
  <div class="mb-6 flex items-start justify-between gap-4">
    <div>
      <button type="button" (click)="goBack()"
        class="mb-2 inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
        Volver a la inscripción
      </button>
      <h2 class="text-2xl font-semibold text-gray-900">Historial del plan de pagos</h2>
      <p class="text-sm text-gray-500">
        Inscripción
        <span class="font-medium text-gray-800">#{{ enrollmentId }}</span>
        <span class="ml-2 rounded-full px-2 py-0.5 text-xs font-medium"
          [ngClass]="enrollmentType === 'corporate' ? 'bg-purple-100 text-purple-700' : 'bg-indigo-100 text-indigo-700'">
          {{ enrollmentType === 'corporate' ? 'Corporativa' : 'Individual' }}
        </span>
        <span *ngIf="participantIdFilter"
          class="ml-2 rounded-full px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700">
          Participante: {{ participantNameFilter || ('#' + participantIdFilter) }}
        </span>
      </p>
      <p *ngIf="participantIdFilter" class="mt-1 text-xs text-gray-400">
        Filtrando versiones del participante seleccionado (se incluyen también las versiones globales de empresa y de todos los participantes).
      </p>
    </div>
    <!-- 🆕 Acciones admin: cambiar versión activa + consolidar versión activa -->
    <div class="flex-shrink-0 flex flex-wrap items-center gap-2">
      <button *ngIf="canSetActiveVersion" type="button" (click)="openSetActiveVersionModal()"
        title="Cambia manualmente qué PaymentPlanVersion queda como activa. Sólo flipea IsActive a nivel versión — NO mueve cuotas ni renumera."
        class="inline-flex items-center gap-2 rounded-full border-2 border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-semibold text-indigo-800 hover:bg-indigo-100 hover:border-indigo-600 transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
        </svg>
        Elegir versión activa
      </button>
      <button *ngIf="canConsolidate" type="button" (click)="openConsolidateModal()"
        title="Mueve TODAS las cuotas activas (IsActive=true) a la versión activa, renumera por fecha. No modifica TotalAmount."
        class="inline-flex items-center gap-2 rounded-full border-2 border-amber-500 bg-amber-50 px-4 py-2 text-sm font-semibold text-amber-800 hover:bg-amber-100 hover:border-amber-600 transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Consolidar versión activa
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="rounded-lg border border-gray-200 bg-white p-12 text-center text-gray-500">
    Cargando historial...
  </div>

  <div *ngIf="error && !loading"
    class="rounded-lg border border-rose-200 bg-rose-50 p-6 text-sm text-rose-700">
    {{ error }}
  </div>

  <div *ngIf="!loading && !error && history && filteredVersions.length === 0"
    class="rounded-lg border border-gray-200 bg-white p-12 text-center text-gray-500">
    <span *ngIf="participantIdFilter">No hay versiones registradas para este participante.</span>
    <span *ngIf="!participantIdFilter">No hay versiones registradas para esta inscripción.</span>
  </div>

  <div *ngIf="!loading && !error && history && filteredVersions.length > 0" class="space-y-3">
    <div *ngFor="let v of filteredVersions; let i = index"
      class="rounded-lg border bg-white shadow-sm"
      [ngClass]="v.isActive ? 'border-emerald-300' : 'border-gray-200'">
      <button type="button" (click)="toggleVersion(v)"
        class="flex w-full items-center justify-between gap-4 p-4 text-left">
        <div class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold"
            [ngClass]="v.isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'">
            v{{ v.version }}
          </span>
          <div>
            <div class="flex items-center gap-2">
              <span class="text-sm font-semibold text-gray-900">Versión {{ v.version }}</span>
              <span *ngIf="v.isActive"
                class="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold text-emerald-700">
                ACTUAL
              </span>
              <span *ngIf="!v.isActive"
                class="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-500">
                Histórica
              </span>
            </div>
            <div class="text-xs text-gray-500">
              Creada el {{ v.createdAt | date:'dd/MM/yyyy HH:mm' }}
              <span *ngIf="v.updatedAt && v.updatedAt !== v.createdAt">
                · Modificada el {{ v.updatedAt | date:'dd/MM/yyyy HH:mm' }}
              </span>
              · {{ v.installmentCount }} {{ v.installmentCount === 1 ? 'cuota' : 'cuotas' }}
              · Total {{ formatCurrency(v.totalAmountToPay) }}
              · Pagado {{ formatCurrency(v.totalAmountPaid) }}
              <span *ngIf="v.performedBy"> · por {{ v.performedBy }}</span>
            </div>
            <!-- 🆕 Motivo + comentario del versionado por grupo -->
            <div *ngIf="v.reasonComment || v.reason != null"
                 class="mt-1 flex items-center gap-2 text-xs">
              <span *ngIf="v.reason != null"
                class="rounded-full bg-indigo-100 px-2 py-0.5 font-semibold text-indigo-700">
                {{ reasonLabel(v.reason) }}
              </span>
              <span *ngIf="v.scope === 'Company'"
                class="rounded-full bg-purple-100 px-2 py-0.5 font-semibold text-purple-700">Empresa</span>
              <span *ngIf="v.scope === 'SingleParticipant' && v.participantName"
                class="rounded-full bg-sky-100 px-2 py-0.5 font-semibold text-sky-700">
                {{ v.participantName }}
              </span>
              <span *ngIf="v.reasonComment" class="italic text-gray-600">"{{ v.reasonComment }}"</span>
            </div>
          </div>
        </div>
        <svg class="h-4 w-4 text-gray-400 transition-transform"
          [class.rotate-180]="v._expanded"
          fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>

      <!-- 🆕 Banner siempre visible para GRUPOS VIRTUALES (sin paymentPlanVersionId):
           explica el problema y ofrece "Promover a versión activa". -->
      <div *ngIf="canPromoteGroup(v)"
        class="flex flex-wrap items-center justify-between gap-3 border-t border-amber-200 bg-amber-50 px-4 py-2.5">
        <div class="flex items-start gap-2 text-xs text-amber-900">
          <svg class="h-4 w-4 mt-0.5 shrink-0 text-amber-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z"/>
          </svg>
          <div>
            <div class="font-semibold">
              Grupo sin
              <span class="font-mono">{{ enrollmentType === 'corporate' ? 'CorporatePaymentPlanVersion' : 'PaymentPlanVersion' }}</span>
              real
            </div>
            <div class="text-amber-800">
              Estas cuotas se agruparon por la columna legacy
              <span class="font-mono">{{ enrollmentType === 'corporate' ? 'CorporatePaymentPlan' : 'PaymentPlan' }}.Version={{ v.version }}</span>
              porque no están enlazadas a una fila real de versionado. Podés promover este grupo a una versión
              real <ng-container *ngIf="enrollmentType === 'corporate'">(Scope inferido automáticamente)</ng-container>
              y dejarla como ACTUAL.
            </div>
          </div>
        </div>
        <button type="button" (click)="openPromoteGroupModal(v)"
          title="Crea una PaymentPlanVersion nueva con VersionNumber=Version legacy, desactiva la anterior, enlaza las cuotas y renumera."
          class="inline-flex items-center gap-1.5 rounded-full border-2 border-amber-600 bg-white px-3 py-1.5 text-xs font-semibold text-amber-800 hover:bg-amber-100 transition-colors whitespace-nowrap">
          <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M5 10l7-7m0 0l7 7m-7-7v18"/>
          </svg>
          Promover a versión activa
        </button>
      </div>

      <div *ngIf="v._expanded" class="border-t border-gray-100 overflow-x-auto">
        <!-- 🆕 Toolbar de selección multi (solo super-admin, no en versión activa).
             Habilitado también para grupos virtuales (paymentPlanVersionId=null);
             el destino del move sigue requiriendo una PaymentPlanVersion real. -->
        <div *ngIf="isSuperAdmin && !v.isActive"
          class="flex flex-wrap items-center justify-between gap-3 bg-indigo-50/40 border-b border-indigo-100 px-4 py-2">
          <div class="flex items-center gap-3 text-xs text-indigo-900">
            <ng-container *ngIf="multiSelectVersionId !== groupKey(v)">
              <span>¿Necesitás mover varias cuotas juntas?</span>
            </ng-container>
            <ng-container *ngIf="multiSelectVersionId === groupKey(v)">
              <span class="font-semibold">
                {{ selectedCuotasInVersion(v).length }} cuota(s) seleccionada(s)
              </span>
              <span *ngIf="selectedCuotasInVersion(v).length > 0" class="text-indigo-700">
                · Hacé click en cada cuota para agregarla al orden de movimiento.
              </span>
            </ng-container>
          </div>
          <div class="flex items-center gap-2">
            <button *ngIf="multiSelectVersionId === groupKey(v) && selectedCuotasInVersion(v).length > 0"
              type="button" (click)="openBatchMoveModal(v)"
              class="inline-flex items-center gap-1.5 rounded-full bg-indigo-600 text-white px-3 py-1.5 text-xs font-semibold hover:bg-indigo-700">
              <svg class="h-3 w-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
              </svg>
              Mover {{ selectedCuotasInVersion(v).length }} a otra versión
            </button>
            <button type="button" (click)="toggleMultiSelectMode(v)"
              class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
              [ngClass]="multiSelectVersionId === groupKey(v)
                ? 'border-indigo-300 bg-white text-indigo-700 hover:bg-indigo-50'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-indigo-50 hover:border-indigo-300'">
              <svg class="h-3 w-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path *ngIf="multiSelectVersionId !== groupKey(v)"
                  stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                <path *ngIf="multiSelectVersionId === groupKey(v)"
                  stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
              {{ multiSelectVersionId === groupKey(v) ? 'Cancelar selección' : 'Seleccionar varias' }}
            </button>
          </div>
        </div>
        <table class="w-full text-sm">
          <thead class="bg-gray-50 text-xs uppercase text-gray-500">
            <tr>
              <!-- 🆕 Columna checkbox: solo visible en modo multi-select de esta versión -->
              <th *ngIf="multiSelectVersionId === groupKey(v)" class="px-3 py-2 text-left w-10">Sel</th>
              <th class="px-3 py-2 text-left"></th>
              <th class="px-3 py-2 text-left">#</th>
              <th class="px-3 py-2 text-left" title="PaymentPlan.Id en DB">ID</th>
              <th class="px-3 py-2 text-left">Vencimiento</th>
              <th class="px-3 py-2 text-right">Monto</th>
              <th class="px-3 py-2 text-right">Pagado</th>
              <th class="px-3 py-2 text-left">Estado</th>
              <th class="px-3 py-2 text-left">Movimiento</th>
              <th *ngIf="history.enrollmentType === 'corporate'" class="px-3 py-2 text-left">Participante</th>
              <th class="px-3 py-2 text-left">Pagos</th>
              <th class="px-3 py-2 text-center">Activa</th>
              <th *ngIf="isSuperAdmin" class="px-3 py-2 text-center" title="Seleccionar para activar en batch">Sel.</th>
              <th *ngIf="isSuperAdmin" class="px-3 py-2 text-right">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            <ng-container *ngFor="let c of v.cuotas">
              <tr [ngClass]="{
                    'bg-gray-50 text-gray-500': !c.isActive && !c._selectionOrder,
                    'bg-amber-50': c.isPunished,
                    'bg-indigo-50 ring-1 ring-indigo-300': c._selectionOrder != null
                  }"
                class="cursor-pointer hover:bg-gray-50" (click)="hasPaymentData(c) && toggleCuota(c)">
                <!-- 🆕 Checkbox de selección (sólo en modo multi-select de esta versión) -->
                <td *ngIf="multiSelectVersionId === groupKey(v)" class="px-3 py-2"
                    (click)="$event.stopPropagation(); toggleCuotaSelection(c, v)">
                  <div class="flex items-center justify-center w-6 h-6 rounded-md border cursor-pointer transition-colors"
                       [ngClass]="c._selectionOrder != null
                         ? 'bg-indigo-600 border-indigo-600 text-white'
                         : 'bg-white border-gray-300 hover:border-indigo-400'">
                    <span *ngIf="c._selectionOrder != null" class="text-xs font-bold">{{ c._selectionOrder }}</span>
                  </div>
                </td>
                <td class="px-3 py-2 text-gray-400">
                  <svg *ngIf="hasPaymentData(c)" class="h-4 w-4 transition-transform"
                    [class.rotate-90]="c._expanded" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </td>
                <td class="px-3 py-2 font-medium">{{ c.installmentNumber }}</td>
                <td class="px-3 py-2 font-mono text-[11px] text-gray-500" title="PaymentPlan.Id">#{{ c.id }}</td>
                <td class="px-3 py-2">{{ c.dueDate | date:'dd/MM/yyyy' }}</td>
                <td class="px-3 py-2 text-right font-medium">{{ formatCurrency(c.amountToPay) }}</td>
                <td class="px-3 py-2 text-right">{{ formatCurrency(c.amountPaid) }}</td>
                <td class="px-3 py-2">
                  <span class="inline-flex items-center gap-1">
                    {{ paymentStatusLabel(c.paymentStatus) }}
                    <svg *ngIf="c.isLocked" class="h-3.5 w-3.5 text-gray-500"
                         title="Cuota inmutable (arrastrada de versión anterior)"
                         fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M5 9V7a5 5 0 0 1 10 0v2h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h1zm2 0h6V7a3 3 0 1 0-6 0v2z"
                        clip-rule="evenodd"></path>
                    </svg>
                  </span>
                </td>
                <td class="px-3 py-2">
                  <span *ngIf="movementTypeLabel(c.movementType)"
                    class="rounded-full bg-indigo-100 px-2 py-0.5 text-xs text-indigo-700">
                    {{ movementTypeLabel(c.movementType) }}
                  </span>
                </td>
                <td *ngIf="history.enrollmentType === 'corporate'" class="px-3 py-2">
                  {{ c.participantName || '-' }}
                </td>
                <td class="px-3 py-2">
                  <div class="flex items-center gap-1 flex-wrap">
                    <span *ngIf="c.incomeReceipts.length > 0"
                      class="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-medium text-emerald-700"
                      title="Comprobantes">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      {{ c.incomeReceipts.length }}
                    </span>
                    <span *ngIf="c.paymentLink"
                      class="inline-flex items-center gap-1 rounded-full bg-indigo-100 px-2 py-0.5 text-[11px] font-medium text-indigo-700"
                      title="Link de pago">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                      </svg>
                      Link
                    </span>
                    <span *ngIf="c.wompiWebhooks.length > 0"
                      class="inline-flex items-center gap-1 rounded-full bg-cyan-100 px-2 py-0.5 text-[11px] font-medium text-cyan-700"
                      title="Webhooks Wompi">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.858 15.355-5.858 21.213 0"></path>
                      </svg>
                      {{ c.wompiWebhooks.length }}
                    </span>
                    <span *ngIf="!hasPaymentData(c)" class="text-xs text-gray-400">-</span>
                  </div>
                </td>
                <td class="px-3 py-2 text-center">
                  <span *ngIf="c.isActive" class="text-emerald-600">●</span>
                  <span *ngIf="!c.isActive" class="text-gray-400">○</span>
                </td>
                <td *ngIf="isSuperAdmin" class="px-3 py-2 text-center" (click)="$event.stopPropagation()">
                  <input *ngIf="!c.isActive" type="checkbox"
                    [checked]="selectedActivateIds.has(c.id)"
                    [disabled]="!canSelectForActivate(c, v) && !selectedActivateIds.has(c.id)"
                    [title]="selectActivateBlockedReason(c, v) || 'Seleccionar para activar en batch'"
                    (change)="toggleActivateSelection(c, v, $event)"
                    class="h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-40" />
                </td>
                <td *ngIf="isSuperAdmin" class="px-3 py-2 text-right" (click)="$event.stopPropagation()">
                  <div class="inline-flex flex-wrap items-center justify-end gap-1.5">
                    <button *ngIf="!c.isActive" type="button" (click)="openActivateSingle(c, v)"
                      title="Activar esta cuota archivada (dentro de su versión actual). No modifica TotalAmount."
                      class="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[11px] font-medium text-emerald-700 hover:bg-emerald-100 hover:border-emerald-300 transition-colors">
                      <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                      Activar
                    </button>
                    <button type="button" (click)="openMoveModal(c, v)"
                      title="Mover esta cuota a otra versión del plan"
                      class="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-[11px] font-medium text-gray-700 hover:bg-indigo-50 hover:border-indigo-300 transition-colors">
                      <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
                      </svg>
                      Mover
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="c._expanded && hasPaymentData(c)" class="bg-slate-50">
                <td *ngIf="multiSelectVersionId === groupKey(v)"></td>
                <td></td>
                <td [attr.colspan]="(history.enrollmentType === 'corporate' ? 10 : 9) + (isSuperAdmin ? 2 : 0)" class="px-4 py-4">
                  <div class="space-y-4">
                    <!-- COMPROBANTES DE INGRESO -->
                    <div *ngIf="c.incomeReceipts.length > 0">
                      <h4 class="text-xs font-bold uppercase text-gray-500 mb-2 flex items-center gap-2">
                        <svg class="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        Comprobantes de Ingreso ({{ c.incomeReceipts.length }})
                      </h4>
                      <div class="overflow-x-auto rounded border border-gray-200 bg-white">
                        <table class="w-full text-xs">
                          <thead class="bg-gray-100 text-gray-600">
                            <tr>
                              <th class="px-2 py-1.5 text-left">CI #</th>
                              <th class="px-2 py-1.5 text-left">Referencia</th>
                              <th class="px-2 py-1.5 text-left">F. Pago</th>
                              <th class="px-2 py-1.5 text-left">F. Creación</th>
                              <th class="px-2 py-1.5 text-right">Bruto</th>
                              <th class="px-2 py-1.5 text-right">Neto</th>
                              <th class="px-2 py-1.5 text-left">Método</th>
                              <th class="px-2 py-1.5 text-left">Banco</th>
                              <th class="px-2 py-1.5 text-left">Estado</th>
                              <th class="px-2 py-1.5 text-center">Conciliado</th>
                            </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-100">
                            <tr *ngFor="let r of c.incomeReceipts">
                              <td class="px-2 py-1.5 font-medium">CI-{{ r.id }}</td>
                              <td class="px-2 py-1.5">{{ r.referenceNumber || '-' }}</td>
                              <td class="px-2 py-1.5">{{ r.transactionDate | date:'dd/MM/yyyy' }}</td>
                              <td class="px-2 py-1.5">{{ r.createdAt | date:'dd/MM/yyyy' }}</td>
                              <td class="px-2 py-1.5 text-right">{{ formatCurrency(r.grossAmount) }}</td>
                              <td class="px-2 py-1.5 text-right">{{ formatCurrency(r.netAmount) }}</td>
                              <td class="px-2 py-1.5">{{ r.paymentMethodName || '-' }}</td>
                              <td class="px-2 py-1.5">{{ r.bankName || '-' }}</td>
                              <td class="px-2 py-1.5">
                                <span class="rounded-full px-2 py-0.5 text-[10px] font-medium"
                                  [ngClass]="receiptStatusClass(r)">
                                  {{ receiptStatusLabel(r) }}
                                </span>
                              </td>
                              <td class="px-2 py-1.5 text-center">
                                <span *ngIf="r.isBankReconciled" class="text-emerald-600">✓</span>
                                <span *ngIf="!r.isBankReconciled" class="text-gray-300">–</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- LINK DE PAGO -->
                    <div *ngIf="c.paymentLink">
                      <h4 class="text-xs font-bold uppercase text-gray-500 mb-2 flex items-center gap-2">
                        <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                        </svg>
                        Link de Pago
                      </h4>
                      <div class="rounded border border-indigo-200 bg-white p-3 text-xs">
                        <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                          <div>
                            <div class="text-gray-500">Wompi Id</div>
                            <div class="font-mono text-gray-800 truncate" [title]="c.paymentLink.wompiLinkId">
                              {{ c.paymentLink.wompiLinkId || '-' }}
                            </div>
                          </div>
                          <div>
                            <div class="text-gray-500">Monto</div>
                            <div class="font-medium">
                              {{ formatCurrency(c.paymentLink.amount) }}
                              <span *ngIf="c.paymentLink.currencyCode" class="text-gray-400">{{ c.paymentLink.currencyCode }}</span>
                            </div>
                          </div>
                          <div>
                            <div class="text-gray-500">Generado</div>
                            <div>{{ c.paymentLink.generatedDate | date:'dd/MM/yyyy HH:mm' }}</div>
                          </div>
                          <div>
                            <div class="text-gray-500">Expiración</div>
                            <div>
                              {{ c.paymentLink.expirationDate | date:'dd/MM/yyyy HH:mm' }}
                              <span *ngIf="c.paymentLink.isExpired"
                                class="ml-1 rounded-full bg-red-100 px-2 py-0.5 text-[10px] text-red-700">Expirado</span>
                            </div>
                          </div>
                          <div>
                            <div class="text-gray-500">Webhook procesado</div>
                            <div>
                              <span *ngIf="c.paymentLink.webhookProcessed" class="text-emerald-600">Sí</span>
                              <span *ngIf="!c.paymentLink.webhookProcessed" class="text-gray-400">No</span>
                            </div>
                          </div>
                          <div>
                            <div class="text-gray-500">Email enviado</div>
                            <div>
                              <span *ngIf="c.paymentLink.emailSent" class="text-emerald-600">Sí</span>
                              <span *ngIf="!c.paymentLink.emailSent" class="text-gray-400">No</span>
                            </div>
                          </div>
                          <div>
                            <div class="text-gray-500">Activo</div>
                            <div>
                              <span *ngIf="c.paymentLink.isActive" class="text-emerald-600">Sí</span>
                              <span *ngIf="!c.paymentLink.isActive" class="text-gray-400">No</span>
                            </div>
                          </div>
                          <div class="col-span-full">
                            <div class="text-gray-500">URL</div>
                            <a *ngIf="c.paymentLink.paymentUrl" [href]="c.paymentLink.paymentUrl" target="_blank"
                              class="text-indigo-600 hover:underline break-all">
                              {{ c.paymentLink.paymentUrl }}
                            </a>
                            <span *ngIf="!c.paymentLink.paymentUrl" class="text-gray-400">-</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- WEBHOOKS WOMPI -->
                    <div *ngIf="c.wompiWebhooks.length > 0">
                      <h4 class="text-xs font-bold uppercase text-gray-500 mb-2 flex items-center gap-2">
                        <svg class="w-4 h-4 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.858 15.355-5.858 21.213 0"></path>
                        </svg>
                        Webhooks de Wompi ({{ c.wompiWebhooks.length }})
                      </h4>
                      <div class="overflow-x-auto rounded border border-gray-200 bg-white">
                        <table class="w-full text-xs">
                          <thead class="bg-gray-100 text-gray-600">
                            <tr>
                              <th class="px-2 py-1.5 text-left">Fecha</th>
                              <th class="px-2 py-1.5 text-left">Transaction Id</th>
                              <th class="px-2 py-1.5 text-left">Evento</th>
                              <th class="px-2 py-1.5 text-left">Estado Tx</th>
                              <th class="px-2 py-1.5 text-right">Monto</th>
                              <th class="px-2 py-1.5 text-left">Método</th>
                              <th class="px-2 py-1.5 text-left">Procesado</th>
                              <th class="px-2 py-1.5 text-right">Reintentos</th>
                            </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-100">
                            <tr *ngFor="let wh of c.wompiWebhooks">
                              <td class="px-2 py-1.5">{{ wh.requestDate | date:'dd/MM/yyyy HH:mm' }}</td>
                              <td class="px-2 py-1.5 font-mono truncate max-w-[200px]" [title]="wh.transactionId">
                                {{ wh.transactionId }}
                              </td>
                              <td class="px-2 py-1.5">{{ wh.eventName || '-' }}</td>
                              <td class="px-2 py-1.5">
                                <span class="rounded-full px-2 py-0.5 text-[10px] font-medium"
                                  [ngClass]="webhookStatusClass(wh.transactionStatus)">
                                  {{ wh.transactionStatus || '-' }}
                                </span>
                              </td>
                              <td class="px-2 py-1.5 text-right">{{ formatWebhookAmount(wh.amountInCents, wh.currency) }}</td>
                              <td class="px-2 py-1.5">{{ wh.paymentMethodType || '-' }}</td>
                              <td class="px-2 py-1.5">
                                <span class="rounded-full px-2 py-0.5 text-[10px] font-medium"
                                  [ngClass]="webhookStatusClass(wh.status)">
                                  {{ wh.status || '-' }}
                                </span>
                                <div *ngIf="wh.failureStep" class="mt-0.5 text-[10px] text-red-600">
                                  ⚠ {{ wh.failureStep }}
                                </div>
                              </td>
                              <td class="px-2 py-1.5 text-right">{{ wh.retryCount }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- 🆕 Barra fija inferior: activar cuotas seleccionadas (solo super-admin) -->
<div *ngIf="isSuperAdmin && selectedActivateIds.size > 0"
     class="fixed bottom-0 inset-x-0 z-40 border-t border-emerald-200 bg-white shadow-[0_-4px_12px_rgba(0,0,0,0.08)]">
  <div class="max-w-6xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">
    <div class="flex items-center gap-2 text-sm">
      <span class="inline-flex items-center justify-center h-6 w-6 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold">
        {{ selectedActivateIds.size }}
      </span>
      <span class="font-medium text-gray-800">cuota(s) seleccionada(s) para activar</span>
      <span class="text-xs text-gray-500 hidden sm:inline">· No modifica el monto contractual de la inscripción</span>
    </div>
    <div class="flex items-center gap-2">
      <button type="button" (click)="clearActivateSelection()"
        class="inline-flex items-center rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50">
        Cancelar selección
      </button>
      <button type="button" (click)="openActivateBatchFromSelection()"
        class="inline-flex items-center gap-1.5 rounded-full border border-emerald-700 bg-emerald-700 px-4 py-1.5 text-sm font-semibold text-white hover:bg-emerald-800">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        Activar {{ selectedActivateIds.size }} cuota(s)
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal: Activar cuota(s) archivada(s) (solo super-admin) -->
<div *ngIf="activateModal.open"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="text-xl font-bold text-gray-900">
          {{ activateModal.mode === 'single' ? 'Activar cuota archivada' : 'Activar cuotas archivadas' }}
        </h2>
        <p *ngIf="activateModal.mode === 'single' && activateModal.cuota" class="mt-1 text-xs text-gray-500">
          Cuota <span class="font-semibold">#{{ activateModal.cuota.installmentNumber }}</span>
          (ID <span class="font-mono">#{{ activateModal.cuota.id }}</span>)
          · Vence {{ activateModal.cuota.dueDate | date:'dd/MM/yyyy' }}
          · {{ formatCurrency(activateModal.cuota.amountToPay) }}
        </p>
        <p *ngIf="activateModal.mode === 'batch'" class="mt-1 text-xs text-gray-500">
          {{ activateModal.cuotaIds.length }} cuota(s) seleccionada(s)
          <span *ngIf="activateModal.versionRef">
            · Versión v{{ activateModal.versionRef.version }}
          </span>
        </p>
      </div>
      <button type="button" (click)="closeActivateModal()" class="rounded-full p-1 text-gray-400 hover:bg-gray-100">
        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>

    <div class="mt-5 space-y-3">
      <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-900">
        <p class="font-semibold">¿Qué va a pasar?</p>
        <ul class="mt-1 list-disc pl-5 space-y-0.5">
          <li>La(s) cuota(s) pasan a <strong>IsActive=true</strong> dentro de su versión actual.</li>
          <li>Se <strong>renumeran</strong> las cuotas activas de esa versión por fecha de vencimiento.</li>
          <li><strong>NO se modifica el monto contractual</strong> de la inscripción (Enrollment.TotalAmount queda igual). Si la suma de cuotas activas queda diferente, aparece el badge "Necesita atención" en el listado.</li>
          <li>Los recibos asociados no se tocan.</li>
        </ul>
      </div>

      <label class="block text-sm font-semibold text-gray-800 mt-3">Motivo de la activación</label>
      <textarea rows="3" [(ngModel)]="activateModal.comment"
        placeholder="Ej: Reversa el retiro anterior. Cliente continúa con el plan."
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"></textarea>
      <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el audit trail (Observations).</p>
    </div>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeActivateModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmActivate()"
        [disabled]="(activateModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center gap-1.5 rounded-full border border-emerald-700 bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800 disabled:opacity-50 disabled:cursor-not-allowed">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        {{ activateModal.mode === 'single' ? 'Activar cuota' : 'Activar ' + activateModal.cuotaIds.length + ' cuota(s)' }}
      </button>
    </div>
  </div>
</div>

<!-- 🔐 Modal: Mover cuota a otra versión (solo super-admin) -->
<div *ngIf="moveModal.open && moveModal.cuota"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="text-xl font-bold text-gray-900">Mover cuota a otra versión</h2>
        <p class="mt-1 text-xs text-gray-500">
          Cuota <span class="font-semibold">#{{ moveModal.cuota.installmentNumber }}</span>
          (ID <span class="font-mono">#{{ moveModal.cuota.id }}</span>)
          · Vence {{ moveModal.cuota.dueDate | date:'dd/MM/yyyy' }}
          · {{ formatCurrency(moveModal.cuota.amountToPay) }}
          <span *ngIf="!moveModal.cuota.isActive" class="ml-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700">archivada</span>
        </p>
        <p class="mt-1 text-xs text-gray-500">
          Versión actual: <span class="font-semibold">v{{ moveModal.sourceVersion?.version }}</span>
          (#{{ moveModal.sourceVersion?.paymentPlanVersionId ?? 'legacy' }})
        </p>
      </div>
      <button type="button" (click)="closeMoveModal()" class="rounded-full p-1 text-gray-400 hover:bg-gray-100">
        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>

    <div class="mt-5 space-y-3">
      <div class="rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-xs text-indigo-900">
        <p class="font-semibold">¿Qué va a pasar?</p>
        <ul class="mt-1 list-disc pl-5 space-y-0.5">
          <li>La cuota se mueve a la versión destino (cambia <span class="font-mono">PaymentPlanVersionId</span>).</li>
          <li>Si la versión destino es la <strong>ACTIVA</strong> y la cuota está archivada, se <strong>reactiva</strong> automáticamente.</li>
          <li>Se <strong>renumeran todas las cuotas activas</strong> de la versión destino por fecha de vencimiento ascendente.</li>
          <li>Los recibos asociados no se tocan (siguen atados por Id/LineageId).</li>
        </ul>
      </div>

      <label class="block text-sm font-semibold text-gray-800">Versión destino</label>
      <select [(ngModel)]="moveModal.targetVersionId"
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm">
        <option [ngValue]="null">— Seleccioná —</option>
        <option *ngFor="let v of availableTargetVersions" [ngValue]="v.paymentPlanVersionId">
          v{{ v.version }} (ID #{{ v.paymentPlanVersionId }})
          {{ v.isActive ? '· ACTIVA' : '· histórica' }}
          · {{ v.installmentCount }} cuota(s)
          <ng-container *ngIf="enrollmentType === 'corporate'">
            · {{ v.scope }}<ng-container *ngIf="v.participantName"> · {{ v.participantName }}</ng-container>
          </ng-container>
        </option>
      </select>
      <p *ngIf="availableTargetVersions.length === 0" class="text-xs text-amber-700">
        No hay versiones destino disponibles
        <ng-container *ngIf="enrollmentType === 'corporate'"> con el mismo scope/participante</ng-container>.
      </p>

      <label class="block text-sm font-semibold text-gray-800 mt-3">Motivo del movimiento</label>
      <textarea rows="3" [(ngModel)]="moveModal.comment"
        placeholder="Ej: Rescatar cuota perdida en la migración de versionado anterior."
        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"></textarea>
      <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el audit trail (Observations).</p>

      <!-- 🆕 Preservar TotalAmount -->
      <label *ngIf="enrollmentType === 'individual'"
        class="mt-3 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="moveModal.preserveTotalAmount"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500" />
        <div class="flex-1">
          <span class="text-sm font-semibold text-amber-900">Preservar monto de inscripción</span>
          <p class="text-xs text-amber-800 mt-0.5">
            No modifica Enrollment.TotalAmount aunque la suma de cuotas activas cambie. El descuadre, si existe, aparece como "Necesita atención" en el listado.
          </p>
        </div>
      </label>
    </div>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeMoveModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmMove()"
        [disabled]="!moveModal.targetVersionId || (moveModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-indigo-700 bg-indigo-700 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-800 disabled:opacity-50 disabled:cursor-not-allowed">
        Mover cuota
      </button>
    </div>
  </div>
</div>

<!-- 🔐 Modal: Mover MÚLTIPLES cuotas a otra versión (batch) -->
<div *ngIf="batchMoveModal.open"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
    <div class="flex items-start justify-between mb-4">
      <div>
        <h2 class="text-xl font-bold text-gray-900">Mover varias cuotas a otra versión</h2>
        <p class="text-sm text-gray-500 mt-1">
          {{ batchMoveModal.selectedCuotas.length }} cuota(s) seleccionada(s) de la versión v{{ batchMoveModal.sourceVersion?.version }}.
        </p>
      </div>
      <button type="button" (click)="closeBatchMoveModal()" class="text-gray-400 hover:text-gray-600">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Lista ordenada de seleccionadas -->
    <div class="mb-4 rounded-lg border border-indigo-200 bg-indigo-50/50 p-3">
      <h3 class="text-xs font-bold uppercase text-indigo-700 mb-2">Orden de movimiento</h3>
      <ol class="space-y-1 text-sm">
        <li *ngFor="let c of batchMoveModal.selectedCuotas; let i = index"
            class="flex items-center justify-between gap-3 py-1 px-2 rounded bg-white border border-indigo-100">
          <div class="flex items-center gap-3">
            <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-600 text-white text-xs font-bold">{{ i + 1 }}</span>
            <span class="font-medium text-gray-900">Cuota #{{ c.installmentNumber }}</span>
            <span class="text-xs text-gray-500 font-mono">#{{ c.id }}</span>
            <span class="text-xs text-gray-600">{{ c.dueDate | date:'dd/MM/yyyy' }}</span>
          </div>
          <span class="text-sm font-medium text-gray-900">{{ formatCurrency(c.amountToPay) }}</span>
        </li>
      </ol>
    </div>

    <!-- Versión destino -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1.5">Versión destino</label>
      <select [(ngModel)]="batchMoveModal.targetVersionId"
        class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none">
        <option [ngValue]="null">Seleccioná una versión...</option>
        <option *ngFor="let v of availableBatchTargetVersions" [ngValue]="v.paymentPlanVersionId">
          v{{ v.version }}
          <ng-container *ngIf="v.isActive"> · ACTUAL</ng-container>
          <ng-container *ngIf="!v.isActive"> · Histórica</ng-container>
          · {{ v.installmentCount }} cuota(s)
          · Total {{ formatCurrency(v.totalAmountToPay) }}
        </option>
      </select>
      <p class="text-xs text-gray-500 mt-1">Si seleccionás la versión actual, las cuotas inactivas se reactivan automáticamente.</p>
    </div>

    <!-- Opción de orden -->
    <div class="mb-4 rounded-lg border border-gray-200 p-3 bg-gray-50">
      <label class="flex items-start gap-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="batchMoveModal.useSelectionOrderForMoved"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
        <div class="flex-1">
          <span class="text-sm font-medium text-gray-900">Conservar el orden de selección</span>
          <p class="text-xs text-gray-600 mt-0.5">
            Si está activado, las cuotas movidas conservan el orden de la lista de arriba (1, 2, 3...)
            y las cuotas preexistentes en la versión destino se renumeran después por fecha.
            Si está desactivado, todas se renumeran por fecha de vencimiento (mismo criterio que el
            "Mover" individual).
          </p>
        </div>
      </label>
    </div>

    <!-- 🆕 Preservar TotalAmount (sólo individual) -->
    <div *ngIf="enrollmentType === 'individual'"
      class="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
      <label class="flex items-start gap-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="batchMoveModal.preserveTotalAmount"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500" />
        <div class="flex-1">
          <span class="text-sm font-semibold text-amber-900">Preservar monto de inscripción</span>
          <p class="text-xs text-amber-800 mt-0.5">
            No modifica Enrollment.TotalAmount aunque la suma de cuotas activas cambie tras el batch.
            Útil para reconstrucciones legacy donde el monto contractual es inmutable. El descuadre,
            si existe, se surfacea como "Necesita atención" en el listado.
          </p>
        </div>
      </label>
    </div>

    <!-- Motivo -->
    <div class="mb-2">
      <label class="block text-sm font-medium text-gray-700 mb-1.5">Motivo / Comentario (obligatorio)</label>
      <textarea [(ngModel)]="batchMoveModal.comment" rows="3"
        placeholder="Explicá por qué movés estas cuotas (mín. 10 caracteres). Queda en el audit trail."
        class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none"></textarea>
      <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en Observations de cada cuota movida.</p>
    </div>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeBatchMoveModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmBatchMove()"
        [disabled]="!batchMoveModal.targetVersionId || (batchMoveModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-indigo-700 bg-indigo-700 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-800 disabled:opacity-50 disabled:cursor-not-allowed">
        Mover {{ batchMoveModal.selectedCuotas.length }} cuota(s)
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal: Cambiar versión activa (sólo flag IsActive a nivel versión) -->
<div *ngIf="setActiveVersionModal.open"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-xl rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start gap-4 mb-4">
      <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-indigo-100">
        <svg class="h-6 w-6 text-indigo-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
        </svg>
      </div>
      <div class="flex-1">
        <h2 class="text-xl font-bold text-gray-900">Elegir versión activa</h2>
        <p class="text-sm text-gray-600 mt-1">
          Marcá UNA versión como activa. La elegida queda con
          <span class="font-mono text-xs">PaymentPlanVersion.IsActive=true</span>, y todas las demás
          pasan a <span class="font-mono text-xs">IsActive=false</span>. <strong>No mueve cuotas, no renumera.</strong>
          Sólo cambia el flag a nivel versión.
        </p>
      </div>
    </div>

    <div class="space-y-2 max-h-80 overflow-y-auto pr-1">
      <label *ngFor="let v of setActiveCandidateVersions"
        class="flex items-start gap-3 rounded-lg border p-3 cursor-pointer transition-colors"
        [ngClass]="setActiveVersionModal.targetVersionId === v.paymentPlanVersionId
                    ? 'border-indigo-400 bg-indigo-50'
                    : 'border-gray-200 bg-white hover:bg-gray-50'">
        <input type="radio" name="setActiveTargetVersion"
          [value]="v.paymentPlanVersionId"
          [(ngModel)]="setActiveVersionModal.targetVersionId"
          class="mt-1 h-4 w-4 text-indigo-600 focus:ring-indigo-500" />
        <div class="flex-1 text-sm">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="font-semibold text-gray-900">Versión v{{ v.version }}</span>
            <span *ngIf="v.isActive"
              class="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold text-emerald-700">ACTUAL</span>
            <span *ngIf="!v.isActive"
              class="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-500">Histórica</span>
            <span class="text-[11px] font-mono text-gray-400">id #{{ v.paymentPlanVersionId }}</span>
          </div>
          <div class="text-xs text-gray-500 mt-0.5">
            Creada el {{ v.createdAt | date:'dd/MM/yyyy HH:mm' }}
            · {{ v.installmentCount }} {{ v.installmentCount === 1 ? 'cuota' : 'cuotas' }}
            · Total {{ formatCurrency(v.totalAmountToPay) }}
            · Pagado {{ formatCurrency(v.totalAmountPaid) }}
            <span *ngIf="v.performedBy"> · por {{ v.performedBy }}</span>
          </div>
          <p *ngIf="v.reasonComment" class="mt-1 text-xs italic text-gray-600">"{{ v.reasonComment }}"</p>
        </div>
      </label>
      <p *ngIf="setActiveCandidateVersions.length === 0" class="text-sm text-gray-500 italic p-3">
        No hay versiones con id real (todas son legacy cuota-por-cuota). Editá el plan primero para
        generar una versión con metadata.
      </p>
    </div>

    <div class="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
      <strong>Atención:</strong> esta operación sólo cambia el flag <span class="font-mono">IsActive</span>
      de cada <span class="font-mono">PaymentPlanVersion</span>. Las cuotas (<span class="font-mono">PaymentPlan</span>)
      <strong>no se tocan</strong>: las que están <span class="font-mono">IsActive=true</span> siguen así,
      en la versión donde estén. Si necesitás mover cuotas o renumerar, usá "Consolidar versión activa"
      o el botón "Mover" por cuota.
    </div>

    <label class="block text-sm font-medium text-gray-700 mb-1.5 mt-4">Motivo / Comentario (obligatorio)</label>
    <textarea [(ngModel)]="setActiveVersionModal.comment" rows="3"
      placeholder="Ej: Versión v0 quedó marcada activa por backfill legacy, dejamos v2 como la real."
      class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none"></textarea>
    <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el audit log (Serilog).</p>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeSetActiveVersionModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmSetActiveVersion()"
        [disabled]="setActiveVersionModal.targetVersionId == null
                    || (setActiveVersionModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-indigo-600 bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed">
        Aplicar
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal: Consolidar versión activa (one-click fix legacy) -->
<div *ngIf="consolidateModal.open"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-xl rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start gap-4 mb-4">
      <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100">
        <svg class="h-6 w-6 text-amber-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
      </div>
      <div class="flex-1">
        <h2 class="text-xl font-bold text-gray-900">Consolidar versión activa</h2>
        <p class="text-sm text-gray-600 mt-1">
          Esta operación toma TODAS las cuotas <span class="font-mono text-xs">IsActive=true</span>
          de la inscripción (en cualquier versión, incluso archivadas) y las trae a la versión activa,
          renumerándolas por fecha de vencimiento.
        </p>
      </div>
    </div>

    <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-3 mb-4">
      <p class="text-xs font-semibold text-emerald-900 mb-1">✓ Lo que SÍ hace:</p>
      <ul class="text-xs text-emerald-800 list-disc pl-5 space-y-0.5">
        <li>Mueve cuotas IsActive=true de versiones históricas a la versión actual.</li>
        <li>Renumera 1..N por fecha de vencimiento ascendente.</li>
        <li>Deja audit trail en Observations de cada cuota.</li>
      </ul>
    </div>

    <div class="rounded-lg border border-amber-200 bg-amber-50 p-3 mb-4">
      <p class="text-xs font-semibold text-amber-900 mb-1">⚠️ Lo que NO hace:</p>
      <ul class="text-xs text-amber-800 list-disc pl-5 space-y-0.5">
        <li><strong>NO modifica Enrollment.TotalAmount</strong> aunque la suma quede diferente.</li>
        <li>Si la suma activa final ≠ TotalAmount, aparece como "Necesita atención" en el listado.</li>
        <li>NO toca cuotas IsActive=false (las archivadas siguen archivadas).</li>
      </ul>
    </div>

    <label class="block text-sm font-medium text-gray-700 mb-1.5">Motivo / Comentario (obligatorio)</label>
    <textarea [(ngModel)]="consolidateModal.comment" rows="3"
      placeholder="Ej: Reconstrucción de plan post-migración cuota-por-cuota."
      class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none"></textarea>
    <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el audit trail de cada cuota movida.</p>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closeConsolidateModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmConsolidate()"
        [disabled]="(consolidateModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-amber-600 bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed">
        Consolidar ahora
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal: Promover grupo virtual a versión activa -->
<div *ngIf="promoteGroupModal.open && promoteGroupModal.targetVersion as target"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="w-full max-w-xl rounded-2xl bg-white p-6 shadow-2xl">
    <div class="flex items-start gap-4 mb-4">
      <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100">
        <svg class="h-6 w-6 text-amber-700" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
        </svg>
      </div>
      <div class="flex-1">
        <h2 class="text-xl font-bold text-gray-900">Promover grupo a versión activa</h2>
        <p class="text-sm text-gray-600 mt-1">
          Vas a crear una
          <span class="font-mono text-xs">{{ enrollmentType === 'corporate' ? 'CorporatePaymentPlanVersion' : 'PaymentPlanVersion' }}</span>
          nueva (con <span class="font-mono text-xs">VersionNumber={{ target.version }}</span>, respetando la
          columna legacy de las cuotas) y dejarla como ACTUAL.
        </p>
      </div>
    </div>

    <div class="rounded-lg border border-gray-200 bg-gray-50 p-3 mb-4 text-sm">
      <div class="font-semibold text-gray-900 mb-1">Grupo a promover</div>
      <div class="text-xs text-gray-700 space-y-0.5">
        <div>
          <span class="font-medium">Versión legacy:</span> v{{ target.version }} (de
          <span class="font-mono">{{ enrollmentType === 'corporate' ? 'CorporatePaymentPlan' : 'PaymentPlan' }}.Version={{ target.version }}</span>)
        </div>
        <div>
          <span class="font-medium">Cuotas en el grupo:</span> {{ target.installmentCount }}
          ({{ target.cuotas.length }} listadas, las que estén activas se enlazan a la nueva versión)
        </div>
        <div>
          <span class="font-medium">Total del grupo:</span> {{ formatCurrency(target.totalAmountToPay) }}
          · <span class="font-medium">Pagado:</span> {{ formatCurrency(target.totalAmountPaid) }}
        </div>
        <!-- 🆕 Corp: Scope inferido + ParticipantId -->
        <ng-container *ngIf="enrollmentType === 'corporate'">
          <div class="pt-1 mt-1 border-t border-gray-200">
            <span class="font-medium">Scope inferido (corp):</span>
            <span class="font-mono">{{ inferredScopeLabel(target) }}</span>
          </div>
          <div>
            <span class="font-medium">ParticipantId del grupo:</span>
            <span class="font-mono">{{ getGroupParticipantIdLabel(target) }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-3 mb-4">
      <p class="text-xs font-semibold text-emerald-900 mb-1">✓ Lo que SÍ hace:</p>
      <ul class="text-xs text-emerald-800 list-disc pl-5 space-y-0.5">
        <li>Desactiva la
          <span class="font-mono">{{ enrollmentType === 'corporate' ? 'CorporatePaymentPlanVersion' : 'PaymentPlanVersion' }}.IsActive=true</span>
          actual <ng-container *ngIf="enrollmentType === 'corporate'">del mismo (Scope, ParticipantId)</ng-container>
          (si existe).
        </li>
        <li>Crea una nueva versión con <span class="font-mono">Reason=AdminFix</span>,
            <span class="font-mono">VersionNumber={{ target.version }}</span>, encadenada por
            <span class="font-mono">PreviousVersionId</span>.</li>
        <li>Asigna la nueva FK a las cuotas activas del grupo.</li>
        <li>Renumera 1..N por fecha de vencimiento.</li>
        <li>Deja audit trail en <span class="font-mono">Observations</span> de cada cuota + Serilog.</li>
      </ul>
    </div>

    <!-- Checkbox sweep: solo aparece si hay otros grupos huérfanos -->
    <label *ngIf="otherOrphanActiveCuotasCount(target) > 0"
      class="flex items-start gap-3 rounded-lg border border-indigo-200 bg-indigo-50 p-3 mb-4 cursor-pointer">
      <input type="checkbox" [(ngModel)]="promoteGroupModal.sweepOtherOrphans"
        class="mt-0.5 h-4 w-4 text-indigo-600 rounded focus:ring-indigo-500" />
      <div class="text-xs text-indigo-900">
        <div class="font-semibold mb-0.5">
          Incluir también {{ otherOrphanActiveCuotasCount(target) }} cuota(s) activa(s) de otros
          {{ otherOrphanGroupsCount(target) }} grupo(s) huérfano(s)
        </div>
        <div class="text-indigo-800">
          <ng-container *ngIf="enrollmentType !== 'corporate'">
            Si está tildado, todas las cuotas con <span class="font-mono">PaymentPlanVersionId=null</span> e
            <span class="font-mono">IsActive=true</span> (de cualquier <span class="font-mono">Version</span> legacy)
            se enlazan a la nueva versión.
          </ng-container>
          <ng-container *ngIf="enrollmentType === 'corporate'">
            Sólo barre cuotas huérfanas del <strong>mismo Scope + mismo ParticipantId</strong>
            (otros valores de <span class="font-mono">Version</span> legacy). NO toca cuotas de otros scopes
            ni participantes (eso violaría el invariante del unique index).
          </ng-container>
          <strong>NO toca</strong> cuotas que ya pertenecen a otra versión real (esas se mueven con "Mover").
        </div>
      </div>
    </label>

    <div class="rounded-lg border border-amber-200 bg-amber-50 p-3 mb-4">
      <p class="text-xs font-semibold text-amber-900 mb-1">⚠️ Lo que NO hace:</p>
      <ul class="text-xs text-amber-800 list-disc pl-5 space-y-0.5">
        <li *ngIf="enrollmentType !== 'corporate'">
          <strong>NO modifica <span class="font-mono">Enrollment.TotalAmount</span></strong> (queda como está).
        </li>
        <li *ngIf="enrollmentType === 'corporate'">
          Corp no persiste TotalAmount a nivel inscripción, así que no hay validación de total.
        </li>
        <li>NO mueve cuotas que ya están enlazadas a una versión real distinta de la nueva.</li>
        <li>NO toca cuotas <span class="font-mono">IsActive=false</span> (las archivadas siguen archivadas).</li>
        <li *ngIf="enrollmentType === 'corporate'">
          Si el grupo (ParticipantId=null) mezcla cuotas COMPANY y PARTICIPANT, la operación falla
          (scope ambiguo) — hay que separar las cuotas antes.
        </li>
      </ul>
      <p class="text-xs text-amber-900 mt-2">
        Si ya existe una versión con
        <span class="font-mono">VersionNumber={{ target.version }}</span>
        <ng-container *ngIf="enrollmentType === 'corporate'"> dentro del mismo (Scope, ParticipantId)</ng-container>,
        la operación falla — hay que resolver el conflicto manualmente antes.
      </p>
    </div>

    <label class="block text-sm font-medium text-gray-700 mb-1.5">Motivo / Comentario (obligatorio)</label>
    <textarea [(ngModel)]="promoteGroupModal.comment" rows="3"
      placeholder="Ej: Inscripción 533 quedó con cuotas v2 huérfanas tras edición cuota-a-cuota; promovemos a versión activa."
      class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-amber-500 focus:outline-none"></textarea>
    <p class="text-xs text-gray-500">Mínimo 10 caracteres. Queda en el audit trail de cada cuota afectada y en el
       <span class="font-mono">ReasonComment</span> de la nueva <span class="font-mono">PaymentPlanVersion</span>.</p>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row">
      <button type="button" (click)="closePromoteGroupModal()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100">
        Cancelar
      </button>
      <button type="button" (click)="confirmPromoteGroup()"
        [disabled]="(promoteGroupModal.comment || '').trim().length < 10"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-amber-600 bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed">
        Promover ahora
      </button>
    </div>
  </div>
</div>

<!-- 🆕 Modal de confirmación secundario (cuando backend pide confirm explícito) -->
<div *ngIf="confirmDialog.open"
     class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
  <div class="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
    <!-- Header con icono de warning -->
    <div class="flex items-start gap-4">
      <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-100">
        <svg class="h-6 w-6 text-amber-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z"/>
        </svg>
      </div>
      <div class="flex-1 pt-0.5">
        <h2 class="text-lg font-bold text-gray-900">{{ confirmDialog.title }}</h2>
        <p class="mt-2 text-sm text-gray-600 leading-relaxed">{{ confirmDialog.message }}</p>
      </div>
    </div>

    <!-- Detalle del cambio de valor (cuando aplique) -->
    <div *ngIf="confirmDialog.currentValue != null && confirmDialog.proposedValue != null"
         class="mt-5 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div class="grid grid-cols-3 gap-2 text-center">
        <div>
          <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Actual</p>
          <p class="mt-1 text-base font-bold text-gray-900">{{ formatCurrency(confirmDialog.currentValue) }}</p>
        </div>
        <div class="flex items-center justify-center">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
          </svg>
        </div>
        <div>
          <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Nuevo</p>
          <p class="mt-1 text-base font-bold text-amber-700">{{ formatCurrency(confirmDialog.proposedValue) }}</p>
        </div>
      </div>
      <div class="mt-3 pt-3 border-t border-amber-200 text-center">
        <span class="text-xs font-medium text-gray-600">Diferencia: </span>
        <span class="text-sm font-bold"
              [class.text-emerald-700]="(confirmDialog.proposedValue - confirmDialog.currentValue) >= 0"
              [class.text-rose-700]="(confirmDialog.proposedValue - confirmDialog.currentValue) < 0">
          {{ formatConfirmDiff() }}
        </span>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-6 flex flex-col-reverse gap-3 sm:flex-row">
      <button type="button" (click)="rejectConfirmDialog()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50">
        Cancelar
      </button>
      <button type="button" (click)="acceptConfirmDialog()"
        class="inline-flex flex-1 items-center justify-center rounded-full border border-amber-600 bg-amber-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-amber-700">
        Sí, aplicar el cambio
      </button>
    </div>
  </div>
</div>
